var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "editactivity_div"
  }, [_c("a-tabs", {
    attrs: {
      "default-active-key": "1"
    },
    on: {
      change: _vm.callback
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("activity.info")
    }
  }, [_vm.type == 1 ? _c("activityinfo", {
    attrs: {
      activityId: _vm.activityId,
      lookinfo: _vm.lookInfo
    }
  }) : _vm._e()], 1), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("activity.productandcustomer")
    }
  }, [_vm.type == 2 ? _c("activityproduct", {
    attrs: {
      activityId: _vm.activityId,
      lookinfo: _vm.lookInfo
    }
  }) : _vm._e()], 1), _c("a-tab-pane", {
    key: "3",
    attrs: {
      tab: _vm.$t("activity.dyxcustomer")
    }
  }, [_vm.type == 3 ? _c("activityDyx", {
    attrs: {
      activityId: _vm.activityId,
      lookinfo: _vm.lookInfo
    }
  }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };